import { RoleDto } from "./RoleDto";
import { UserRoleDto } from "./UserRoleDto";

export class UserDto {
  id: number;
  userName: string;
  normalizedUserName: string;
  email: string;
  normalizedEmail: string;
  emailConfirmed: boolean;
  passwordHash: string;
  securityStamp: string;
  concurrencyStamp: string;
  phoneNumber: string;
  phoneNumberConfirmed: boolean;
  twoFactorEnabled: boolean;
  lockoutEnd: string | null;
  lockoutEnabled: boolean;
  accessFailedCount: number;
  firstName: string;
  lastName: string;
  dateOfBirth: Date | null;
  createdOn: Date;
  photoUrl: string;
  defaultLanguage: string;
  isActive: boolean;
  emiratesId: string;
  companyName: string;
  countryName: string;
  cityName: string;
  note: string;
  userTypeId: number;
  userRoles: UserRoleDto[];
  allSystemRoles: RoleDto[];
  allSystemUsers: UserDto[];
  access_token: string;
  expiration: string;
  isLoggedIn: boolean = false;
  confirmPassword: string;
  legalName: string;
  digitalSignature: string;
  enableDefaultDiscount: boolean;
  defaultDiscountPercentage: number;
  userTypeName: string;
  statusId: number;
  statusName: string;
  parentUserId?: number;
  parentUserName: string;
  dueAmount: number;
  isSigned: boolean;
}
